import { render } from "./EmbassyDetail.vue?vue&type=template&id=084c909b&scoped=true"
import script from "./EmbassyDetail.vue?vue&type=script&lang=js"
export * from "./EmbassyDetail.vue?vue&type=script&lang=js"

import "./EmbassyDetail.vue?vue&type=style&index=0&id=084c909b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084c909b"]])

export default __exports__